<template>
  <base-dialog-adm :show="true"
                    title="回填寄件日期"
                    width="600"
                    btn-confirm-text="儲存"
                    @close="close"
                    @save="commit"
                 >
      <base-box>
        <v-container grid-list-md>
          <v-layout row
                    wrap
                    class="form">
            <v-flex >
              <v-layout row>
                <v-flex sm4>
                  <sub-header class="required"><template v-slot:title>寄送書面分析報告日期</template></sub-header>
                </v-flex>
                <v-flex sm6>
                  <validation-observer ref="observer">
                    <v-menu v-model="menu"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        lazy
                        transition="scale-transition"
                        offset-y
                        full-width>
                    <template v-slot:activator="{ on }">
                      <b-text-field  v-model="writSendDate"
                              readonly
                              placeholder="請選擇"
                              v-on="on"
                              clearable
                              rules="required"
                              vname="寄送書面分析報告日期"
                              vid="writSendDate"
                              maxlength="10"
                              class="date-picker-input"
                              outline>
                          <template v-slot:append>
                            <v-fade-transition leave-absolute>
                              <img width="24"
                              height="24"
                              @click="menu = true"
                              src="@/assets/icon_calendar.svg"
                              alt="calendar">
                            </v-fade-transition>
                          </template>
                        </b-text-field>
                      </template>
                      <v-date-picker v-model="writSendDate"
                              no-title
                              :header-date-format="headerFormatDates"
                              @input="menu = false">
                              </v-date-picker>
                      </v-menu>
                  </validation-observer>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-container>
      </base-box>
    </base-dialog-adm>
</template>
<script>
import {  datepickerFormat } from '@/mixin'

export default {
  name: 'writ-send-date',

  mixins: [datepickerFormat],
  props: {
    item: {
      type: Object
    },
  },
  data () {
    return {
      menu: false,
      writSendDate: null,
    }
  },
  computed: {
  },
  created () {
    let vm = this
  },
  methods: {
    commit () {
      const { writSendDate, } = this
      const { transCode, } = this.item
      this.$doValidate('observer').then(isValid => {
        if (isValid) {
          this.$emit('commit', {writSendDate, transCode})
        }
      })
    },
    close () {
      const { transCode  } = this.item
      this.$emit('close', {transCode})
    },
  }
}
</script>
<style lang="stylus" scoped>

</style>
